import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { BackendLoyaltyService } from '../../services/backend-loyalty.service';
import { IBonusPointsModel } from '../../models/loyalty/IBonusPoints.model';
import { BonusPointsActions } from '../../actions/loyalty/actions-bonus-points';
import * as BonusPointsAction from '../../actions/loyalty/actions-bonus-points';

@Injectable()
export class EffectsBonusPoints {
  getBonusPoints$: Observable<BonusPointsActions> = createEffect(() => {
    return this.actions$.pipe(
      ofType<BonusPointsAction.GetBonusPoints>(BonusPointsAction.GET_BONUS_POINTS),
      switchMap(() =>
        this.backendLoyaltyService.getLoyaltyBonusPoints().pipe(
          map((data: IBonusPointsModel) => new BonusPointsAction.GetBonusPointsSuccess(data)),
          catchError(() => of(new BonusPointsAction.GetBonusPointsError('pageSectionIsNotAvailable')))
        )
      )
    )
  });

  constructor(
    private readonly actions$: Actions,
    private readonly http: HttpClient,
    private readonly backendLoyaltyService: BackendLoyaltyService
  ) { }
}
